// globals: jQuery

/**
 * CardConnectEMVTerminal
 *
 * @author Himanshu Rajput
 *
 * @param params
 * @constructor
 * @returns {CardConnectEMVTerminal}
 */
function CardConnectEMVTerminal(params) {
    this.params = params ? params : {};
}

/**
 * @description Connect EMV Terminal Request for CardConnect
 * @param params
 * @param callback
 */
CardConnectEMVTerminal.prototype.callTerminal = function (params, callback) {
    var self = this;

    function runQuery(step) {
        self.callTerminalInProgress = true;
        jQuery.ajax({
            type: "POST",
            dataType: "json",
            url: '/payment/connect-terminal',
            timeout: 5000,
            success: function (data) {
                jQuery('body').caLoadingSplash('hide');
                if(data.status) {
                    callback(data);
                    self.callTerminalInProgress = false;
                } else {
                    alert(data.message);
                }
            },
            error: function () {
                if (step < 4) {
                    step++;
                    runQuery(step);
                } else {
                    self.callTerminalInProgress = false;
                    jQuery('body').caLoadingSplash('hide');
                    alert('Timeout');
                }
            }
        });
    };
    if (!this.callTerminalInProgress) {
        jQuery('body').caLoadingSplash('show');
        runQuery(0);
    }
};

export default CardConnectEMVTerminal;
